import { lazy } from 'react'
import { Translation } from 'react-i18next'
import { Navigate, Route } from 'react-router-dom'

import GalleryProvider from '@/therapist/contexts/GalleryContext'
import AdministratorKeyIcon from '@/ui/assets/AdministratorKeyIcon'
import AutomationCircleIcon from '@/ui/assets/AutomationCircleIcon'
import ClinicIcon from '@/ui/assets/ClinicIcon'
import CompanyIcon from '@/ui/assets/CompanyIcon'
import DatabaseIcon from '@/ui/assets/DatabaseIcon'
// TEMP REMOVE REPORT
// import DocumentPaperPenIcon from '@/ui/assets/DocumentPaperPenIcon'
import FileTreeIcon from '@/ui/assets/FileTreeIcon'
import GlassAndLiquidIcon from '@/ui/assets/GlassAndLiquidIcon'
import HomeIcon from '@/ui/assets/HomeIcon'
import IntegrationIcon from '@/ui/assets/IntegrationIcon'
import ListBulletsIcon from '@/ui/assets/ListBulletsIcon'
import ManagementSessionsIcon from '@/ui/assets/ManagementSessionsIcon'
import MedicalCrossIcon from '@/ui/assets/MedicalCrossIcon'
import OperationalIcon from '@/ui/assets/OperationalIcon'
import PersonIcon from '@/ui/assets/PersonIcon'
import PersonThreeResponsibleIcon from '@/ui/assets/PersonThreeResponsibleIcon'
import SettingsCogIcon from '@/ui/assets/SettingsCogIcon'
import TagIcon from '@/ui/assets/TagIcon'
import TherapistIcon from '@/ui/assets/TherapistIcon'
import TicketIcon from '@/ui/assets/TicketIcon'
import ToyIcon from '@/ui/assets/ToyIcon'
import { FeedPostMultiSelectionProvider } from '@/ui/hoc/MultiSelection/feedPost'
import { adminRouteNames } from '@/ui/routes/routesNames/adminRouteNames'

import { MultiSelectionProvider } from '../hoc/MultiSelection'
import { PersonaFilterProvider } from '../modules/admin/views/Operational/context/PersonaFilterContext'

const InternalLayout = lazy(() => import('@/ui/layouts/InternalLayout'))

const ClinicAdministrators = lazy(
  () => import('../modules/admin/views/Administrators')
)
const Therapists = lazy(() => import('../modules/admin/views/Therapists'))
const Operator = lazy(() => import('../modules/admin/views/Operational'))
const Patients = lazy(() => import('../modules/admin/views/Patients'))
const ClinicTasksChecklists = lazy(
  () => import('../modules/admin/views/DefaultChecklists')
)
const GroupUsersList = lazy(() => import('../modules/admin/views/GroupUsers'))
const GroupDetails = lazy(
  () => import('../modules/admin/views/GroupUsers/GroupDetails')
)
const Configurations = lazy(
  () => import('../modules/admin/views/Configurations')
)
const Dashboard = lazy(() => import('../modules/admin/views/Dashboard'))
const ResponsiblesPage = lazy(
  () => import('../modules/admin/views/Responsibles')
)
const ClinicTagsPage = lazy(() => import('../modules/admin/views/Tags'))
const Liquids = lazy(() => import('../modules/admin/views/Liquids'))
const Belongs = lazy(() => import('../modules/admin/views/Belongs'))
const Remedies = lazy(() => import('../modules/admin/views/Remedies'))
const Integrations = lazy(() => import('../modules/admin/views/Integrations'))
const Profile = lazy(() => import('@/therapist/pages/profile'))
const TemplateArquive = lazy(
  () => import('../modules/admin/views/templatesArquive')
)
const ListGroupsFeedPermission = lazy(
  () => import('../modules/admin/views/listGroupFeedPermissions/index')
)
const ProfileInfo = lazy(() => import('@/shared/pages/client'))
const CompanyManager = lazy(
  () => import('../modules/admin/views/CompanyManager')
)

const IntegrationStatus = lazy(
  () => import('../modules/admin/views/IntegrationStatus')
)
const Tickets = lazy(() => import('../modules/admin/views/Tickets'))
// TEMP REMOVE REPORT
// const Documents = lazy(() => import('./views/Documents'))
const ManagementSessions = lazy(
  () => import('../modules/admin/views/ManagementSessions')
)
const FileEditor = lazy(() => import('@/ui/modules/file-editor/views'))
const Gallery = lazy(() => import('@/therapist/pages/patient-profile/gallery'))

export function AdminRoutes() {
  return (
    <>
      <Route
        path={adminRouteNames.home}
        element={<Navigate to={adminRouteNames.dashboard} replace={true} />}
      />

      <Route
        element={
          <Translation>
            {(t) => (
              <InternalLayout
                homeLink={adminRouteNames.dashboard}
                menuItems={[
                  {
                    name: 'Dashboard',
                    icon: <HomeIcon />,
                    navigateTo: adminRouteNames.dashboard
                  },
                  {
                    name: 'Automações',
                    icon: <AutomationCircleIcon />,
                    subMenu: [
                      {
                        name: t('internalLayout.admin.integrations'),
                        icon: <IntegrationIcon />,
                        navigateTo: adminRouteNames.integrations
                      },
                      {
                        name: t('internalLayout.admin.integrationStatus'),
                        icon: <DatabaseIcon />,
                        navigateTo: adminRouteNames.integrationStatus
                      },
                      {
                        name: t('internalLayout.admin.listGroups'),
                        icon: <ListBulletsIcon />,
                        navigateTo: adminRouteNames.listGroupFeed
                      },
                      {
                        name: t('internalLayout.admin.templatesFolder'),
                        icon: <FileTreeIcon />,
                        navigateTo: adminRouteNames.templateArquive
                      }
                    ]
                  },
                  {
                    name: 'Clínica',
                    icon: <ClinicIcon />,
                    subMenu: [
                      {
                        name: 'Configurações',
                        icon: <SettingsCogIcon />,
                        navigateTo: adminRouteNames.configurations
                      },
                      {
                        name: 'Empresa',
                        icon: <CompanyIcon />,
                        navigateTo: adminRouteNames.company
                      },
                      {
                        name: 'Etiquetas',
                        icon: <TagIcon />,
                        navigateTo: adminRouteNames.tags
                      },
                      {
                        name: 'Perfis de Acesso',
                        icon: <PersonThreeResponsibleIcon />,
                        navigateTo: adminRouteNames.usersGroups
                      },
                      {
                        name: t('internalLayout.admin.recipients'),
                        icon: <GlassAndLiquidIcon />,
                        navigateTo: adminRouteNames.liquids
                      },
                      {
                        name: t('internalLayout.admin.tickets'),
                        icon: <TicketIcon />,
                        navigateTo: adminRouteNames.tickets
                      },
                      {
                        name: t('internalLayout.admin.remedies'),
                        icon: <MedicalCrossIcon />,
                        navigateTo: adminRouteNames.remedies
                      },
                      {
                        name: t('internalLayout.admin.belongs'),
                        icon: <ToyIcon />,
                        navigateTo: adminRouteNames.belongs
                      }
                      // TEMP REMOVE REPORT
                      // {
                      //   name: t('internalLayout.admin.documents'),
                      //   icon: <DocumentPaperPenIcon />,
                      //   navigateTo: adminRouteNames.documents
                      // },
                      // {
                      //   name: t('internalLayout.admin.managementSessions'),
                      //   icon: <ManagementSessionsIcon />,
                      //   navigateTo: adminRouteNames.managementSessions
                      // }
                    ]
                  },
                  {
                    name: 'Usuários',
                    icon: <PersonIcon />,
                    subMenu: [
                      {
                        name: 'Administradores',
                        icon: <AdministratorKeyIcon />,
                        navigateTo: adminRouteNames.admins
                      },
                      {
                        name: 'Clientes',
                        icon: <PersonIcon />,
                        navigateTo: adminRouteNames.patients
                      },
                      {
                        name: 'Operacionais',
                        icon: <OperationalIcon strokeWidth={'1'} />,
                        navigateTo: adminRouteNames.operational
                      },
                      {
                        name: 'Responsáveis',
                        icon: <PersonThreeResponsibleIcon />,
                        navigateTo: adminRouteNames.responsibles
                      },
                      {
                        name: 'Parceiros',
                        icon: <TherapistIcon />,
                        navigateTo: adminRouteNames.therapists
                      }
                    ]
                  }
                ]}
                searchItems={[
                  {
                    name: 'Dashboard',
                    icon: <HomeIcon />,
                    route: adminRouteNames.dashboard
                  },
                  {
                    name: 'Automações',
                    icon: <AutomationCircleIcon />,
                    children: [
                      {
                        name: t('internalLayout.admin.integrations'),
                        icon: <IntegrationIcon />,
                        route: adminRouteNames.integrations,
                        module: 'Automações'
                      },
                      {
                        name: t('internalLayout.admin.integrationStatus'),
                        icon: <DatabaseIcon />,
                        route: adminRouteNames.integrationStatus,
                        module: 'Automações'
                      },
                      {
                        name: t('internalLayout.admin.listGroups'),
                        icon: <ListBulletsIcon />,
                        route: adminRouteNames.listGroupFeed,
                        module: 'Automações',
                        children: [
                          {
                            name: t('patient.sidebar.items.gallery'),
                            route: adminRouteNames.gallery,
                            isSearchable: false,
                            isNavigatable: false,
                            children: [
                              {
                                name: 'Editor de arquivo',
                                route: adminRouteNames.fileEditor,
                                isSearchable: false,
                                isNavigatable: false
                              }
                            ]
                          }
                        ]
                      },
                      {
                        name: t('internalLayout.admin.templatesFolder'),
                        icon: <FileTreeIcon />,
                        route: adminRouteNames.templateArquive,
                        module: 'Automações'
                      }
                    ]
                  },
                  {
                    name: 'Clínica',
                    icon: <ClinicIcon />,
                    children: [
                      {
                        name: 'Configurações',
                        icon: <SettingsCogIcon />,
                        route: adminRouteNames.configurations,
                        module: 'Clínica'
                      },
                      {
                        name: 'Empresa',
                        icon: <CompanyIcon />,
                        route: adminRouteNames.company,
                        module: 'Clínica'
                      },
                      {
                        name: 'Etiquetas',
                        icon: <TagIcon />,
                        route: adminRouteNames.tags,
                        module: 'Clínica'
                      },
                      {
                        name: 'Perfis de Acesso',
                        icon: <PersonThreeResponsibleIcon />,
                        route: adminRouteNames.usersGroups,
                        module: 'Clínica'
                      },
                      {
                        name: t('internalLayout.admin.recipients'),
                        icon: <GlassAndLiquidIcon />,
                        route: adminRouteNames.liquids,
                        module: 'Clínica'
                      },
                      {
                        name: t('internalLayout.admin.tickets'),
                        icon: <TicketIcon />,
                        route: adminRouteNames.tickets,
                        module: 'Clínica'
                      },
                      {
                        name: t('internalLayout.admin.remedies'),
                        icon: <MedicalCrossIcon />,
                        route: adminRouteNames.remedies,
                        module: 'Clínica'
                      },
                      {
                        name: t('internalLayout.admin.belongs'),
                        icon: <ToyIcon />,
                        route: adminRouteNames.belongs,
                        module: 'Clínica'
                      },
                      // TEMP REMOVE REPORT
                      // {
                      //   name: t('internalLayout.admin.documents'),
                      //   icon: <DocumentPaperPenIcon />,
                      //   route: adminRouteNames.documents,
                      //   module: 'Clínica'
                      // },
                      {
                        name: t('internalLayout.admin.managementSessions'),
                        icon: <ManagementSessionsIcon />,
                        route: adminRouteNames.managementSessions,
                        module: 'Clínica'
                      }
                    ]
                  },
                  {
                    name: 'Usuários',
                    icon: <PersonIcon />,
                    children: [
                      {
                        name: 'Administradores',
                        icon: <AdministratorKeyIcon />,
                        route: adminRouteNames.admins,
                        module: 'Usuários'
                      },
                      {
                        name: 'Clientes',
                        icon: <PersonIcon />,
                        route: adminRouteNames.patients,
                        module: 'Usuários'
                      },
                      {
                        name: 'Operacionais',
                        icon: <OperationalIcon strokeWidth={'1'} />,
                        route: adminRouteNames.operational,
                        module: 'Usuários'
                      },
                      {
                        name: 'Responsáveis',
                        icon: <PersonThreeResponsibleIcon />,
                        route: adminRouteNames.responsibles,
                        module: 'Usuários'
                      },
                      {
                        name: 'Parceiros',
                        icon: <TherapistIcon />,
                        route: adminRouteNames.therapists,
                        module: 'Usuários'
                      }
                    ]
                  }
                ]}
              />
            )}
          </Translation>
        }
      >
        <Route path={adminRouteNames.dashboard} element={<Dashboard />} />
        <Route path={adminRouteNames.profile} element={<Profile />} />
        <Route path={adminRouteNames.profileInfo} element={<ProfileInfo />} />
        <Route
          path={adminRouteNames.usersGroups}
          element={<GroupUsersList />}
        />
        <Route
          path={adminRouteNames.groupDetails}
          element={
            <FeedPostMultiSelectionProvider>
              <GroupDetails />
            </FeedPostMultiSelectionProvider>
          }
        />
        <Route
          path={adminRouteNames.admins}
          element={<ClinicAdministrators />}
        />
        <Route
          path={adminRouteNames.configurations}
          element={<Configurations />}
        />
        <Route
          path={adminRouteNames.therapists}
          element={
            <PersonaFilterProvider key={adminRouteNames.therapists}>
              <Therapists />
            </PersonaFilterProvider>
          }
        />
        <Route
          path={adminRouteNames.operational}
          element={
            <PersonaFilterProvider key={adminRouteNames.operational}>
              <Operator />
            </PersonaFilterProvider>
          }
        />
        <Route path={adminRouteNames.patients} element={<Patients />} />
        <Route
          path={adminRouteNames.tasksChecklist}
          element={<ClinicTasksChecklists />}
        />
        <Route
          path={adminRouteNames.responsibles}
          element={
            <PersonaFilterProvider key={adminRouteNames.responsibles}>
              <ResponsiblesPage />
            </PersonaFilterProvider>
          }
        />
        <Route path={adminRouteNames.tags} element={<ClinicTagsPage />} />
        <Route path={adminRouteNames.liquids} element={<Liquids />} />
        <Route path={adminRouteNames.tickets} element={<Tickets />} />
        <Route path={adminRouteNames.belongs} element={<Belongs />} />
        <Route path={adminRouteNames.remedies} element={<Remedies />} />
        <Route path={adminRouteNames.integrations} element={<Integrations />} />
        <Route
          path={adminRouteNames.integrationStatus}
          element={<IntegrationStatus />}
        />
        <Route
          path={adminRouteNames.templateArquive}
          element={<TemplateArquive />}
        />
        <Route
          path={adminRouteNames.listGroupFeed}
          element={<ListGroupsFeedPermission />}
        />
        <Route path={adminRouteNames.company} element={<CompanyManager />} />
        <Route path={adminRouteNames.fileEditor} element={<FileEditor />} />
        <Route
          path={adminRouteNames.managementSessions}
          element={<ManagementSessions />}
        />
        <Route
          path={adminRouteNames.gallery}
          element={
            <MultiSelectionProvider>
              <GalleryProvider>
                <Gallery />
              </GalleryProvider>
            </MultiSelectionProvider>
          }
        />
        <Route
          path={adminRouteNames.galleryItem}
          element={
            <MultiSelectionProvider>
              <GalleryProvider>
                <Gallery />
              </GalleryProvider>
            </MultiSelectionProvider>
          }
        />
        <Route
          path={adminRouteNames.galleryFolder}
          element={
            <MultiSelectionProvider>
              <GalleryProvider>
                <Gallery />
              </GalleryProvider>
            </MultiSelectionProvider>
          }
        />
      </Route>
    </>
  )
}
